module.exports = __webpack_public_path__ + "img/category_drywalling.7ba5ce6a.jpg";